import { Link } from '@synapex/shared2/gateway-rest-api';

import { parseDateField } from '../../utils';

////////////////////parts

export const siteLinkUrl = (
  data: NonNullable<Link.Site.OneReply['siteLinkUrl']>,
) => {
  parseDateField(data, 'updated_at');

  return data;
};

export const siteLink = (data: Link.Site.OneReply) => {
  parseDateField(data, 'created_at');
  parseDateField(data, 'updated_at');
  parseDateField(data, 'published_at');
  parseDateField(data, 'deleted_at');

  if (data.siteLinkUrl) {
    siteLinkUrl(data.siteLinkUrl);
  }

  return data;
};

export const channelLink = (data: Link.Channel.OneReply) => {
  parseDateField(data, 'created_at');
  parseDateField(data, 'updated_at');
  parseDateField(data, 'published_at');
  parseDateField(data, 'deleted_at');

  return data;
};

////////////////////replies

export const siteLinkManyReply = (data: Link.Site.ManyReply) => {
  for (const item of data) {
    siteLink(item);
  }

  return data;
};

export const channelLinkManyReply = (data: Link.Channel.ManyReply) => {
  for (const item of data) {
    channelLink(item);
  }

  return data;
};
